if (!customElements.get('collection-tabs')) {
    class CollectionTabs extends HTMLElement {
        constructor() {
            super();
            this.tabs = this.querySelectorAll('.collection-tabs__tab');
            this.panels = this.querySelectorAll('.collection-tabs__panel');

            this.tabs.forEach(tab => {
                tab.addEventListener('click', () => {
                    this.switchTab(tab);
                });
            });
        }

        switchTab(selectedTab) {
            const index = selectedTab.dataset.index;

            this.tabs.forEach(tab => {
                tab.classList.remove('is-active');
                tab.setAttribute('aria-selected', 'false');
            });

            this.panels.forEach(panel => {
                panel.classList.remove('is-active');
                panel.setAttribute('hidden', 'true');
            });

            selectedTab.classList.add('is-active');
            selectedTab.setAttribute('aria-selected', 'true');

            const activePanel = this.querySelector(`#Panel-${this.dataset.sectionId}-${parseInt(index) + 1}`);
            if (activePanel) {
                activePanel.classList.add('is-active');
                activePanel.removeAttribute('hidden');
            }
        }
    }

    customElements.define('collection-tabs', CollectionTabs);
}
